import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageKey, UserLanguage, UserTimeLogOff } from "@royalty/model";
import { CoreToolbox } from '../core/utils/core-toolbox';

@Injectable()
export class UserSettingService {
	constructor(private translate: TranslateService) {}

	public getDefaultLanguage(): string {
		return CoreToolbox.storageService.getItem(LocalStorageKey.language) || "vi";
	}

	public getDefaultTimeLoggoff(): number {
		const logOff = CoreToolbox.storageService.getItem(LocalStorageKey.logOff) || 30;
		return Number(logOff);
		debugger;
	}

	public setDefaultLanguage(languageCode: string) {
		CoreToolbox.storageService.setItem(LocalStorageKey.language, languageCode);
	}

	public useDefaultLanguage(): void {
		const lang = this.getDefaultLanguage();
		// this language will be used as a fallback when a translation isn't found in the current language
		this.translate.setDefaultLang(lang);
		// the lang to use, if the lang isn't available, it will use the current loader to get them
		this.translate.use(lang);
	}

	public getListLanguageSupport(): UserLanguage[] {
		return [
			{ name: "English", code: "en" },
			{ name: "Chinese", code: "zh" },
			{ name: "Vietnamese", code: "vi" }
		] as UserLanguage[];
	}

	public getListUserTimeLogOff(): UserTimeLogOff[] {
		return [
			{
				name: "10 seconds",
				value: 10
			},
			{
				name: "20 seconds",
				value: 20
			},
			{
				name: "30 seconds",
				value: 30
			},
			{
				name: "1 min",
				value: 60
			},
			{
				name: "5 mins",
				value: 300
			},
			{
				name: "10 mins",
				value: 600
			}
		] as UserTimeLogOff[];
	}
}
